import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {
    IHybridEmbeddedGameLoadingIndicatorViewModel
} from "../../../../services/game-runner/loading-indicators/hybrid-embedded-game-loading-indicator-view-model.interface";
import {HybridEmbeddedGameLoadingIndicatorRootBox} from "./boxes/root/hybrid-embedded-game-loading-indicator-root.box";
import {
    HybridEmbeddedGameLoadingIndicatorHeaderBox
} from "./boxes/header/hybrid-embedded-game-loading-indicator-header.box";
import {
    HybridEmbeddedGameLoadingIndicatorContentBox
} from "./boxes/content/hybrid-embedded-game-loading-indicator-content.box";
import {
    HybridEmbeddedGameLoadingIndicatorSpinnerBox
} from "./boxes/spinner/hybrid-embedded-game-loading-indicator-spinner.box";
import {
    HybridEmbeddedGameLoadingIndicatorProgressCircle1Box,
    HybridEmbeddedGameLoadingIndicatorProgressCircle2Box, HybridEmbeddedGameLoadingIndicatorProgressCircle3Box
} from "./boxes/progress/hybrid-embedded-game-loading-indicator-progress.box";
import {LoadingCircleLargeIcon} from "../../../../themes/defaults/icons/loading-circle-large.icon";
import {
    GameHeaderBarCloseButtonBox
} from "../../header-bar/common/boxes/close-game-button/game-header-bar-close-button.box";

interface HybridEmbeddedGameLoadingIndicatorComponentProps {
    viewModel: IHybridEmbeddedGameLoadingIndicatorViewModel;
}

export const HybridEmbeddedGameLoadingIndicatorComponent = observer(
    class HybridEmbeddedGameLoadingIndicatorComponent extends OrbitComponent<HybridEmbeddedGameLoadingIndicatorComponentProps> {

        private _onCloseButtonClick = () => {
            this.props.viewModel.closeLoadingIndicator();
        }

        private _renderPackageDownloadStatusLabel() {
            if(this.props.viewModel.totalPackages > 1) {
                return (
                    <div>
                        {this.services.translation.translate('HYBRID_EMBEDDED_GAME_LOADING_PACKAGES_PROGRESS', {packagesStatus: `${this.props.viewModel.currentPackage}/${this.props.viewModel.totalPackages}`})}
                    </div>
                );
            }

            return null;
        }

        private _renderConnectingSpinner() {
            return (
                <>
                    <div>
                        {this.services.translation.translate('HYBRID_EMBEDDED_GAME_LOADING_SPINNER_LABEL')}
                    </div>
                    <HybridEmbeddedGameLoadingIndicatorSpinnerBox>
                        <LoadingCircleLargeIcon size={10}/>
                    </HybridEmbeddedGameLoadingIndicatorSpinnerBox>
                </>
            );
        }

        private _renderProgressIndicator() {
            return (
                <>
                    {this._renderPackageDownloadStatusLabel()}
                    <HybridEmbeddedGameLoadingIndicatorProgressCircle1Box>
                        <HybridEmbeddedGameLoadingIndicatorProgressCircle2Box angle={this.props.viewModel.downloadPercentage / 100 * 360}>
                            <HybridEmbeddedGameLoadingIndicatorProgressCircle3Box>
                                {`${this.props.viewModel.downloadPercentage}%`}
                            </HybridEmbeddedGameLoadingIndicatorProgressCircle3Box>
                        </HybridEmbeddedGameLoadingIndicatorProgressCircle2Box>
                    </HybridEmbeddedGameLoadingIndicatorProgressCircle1Box>
                </>

            )
        }

        private _renderContent() {
            if(this.props.viewModel.downloadPercentage === 0 && this.props.viewModel.currentPackage === 1) {
                return this._renderConnectingSpinner();
            } else {
                return this._renderProgressIndicator();
            }
        }

        render() {
            return (
                <HybridEmbeddedGameLoadingIndicatorRootBox>
                    <HybridEmbeddedGameLoadingIndicatorHeaderBox>
                        <GameHeaderBarCloseButtonBox onClick={this._onCloseButtonClick}/>
                    </HybridEmbeddedGameLoadingIndicatorHeaderBox>
                    <HybridEmbeddedGameLoadingIndicatorContentBox>
                        {this._renderContent()}
                    </HybridEmbeddedGameLoadingIndicatorContentBox>
                </HybridEmbeddedGameLoadingIndicatorRootBox>
            )
        }
    }
);